import { render, staticRenderFns } from "./TaskProject.vue?vue&type=template&id=0aae9604&"
import script from "./TaskProject.vue?vue&type=script&lang=js&"
export * from "./TaskProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports